import React, {FC, useMemo} from "react";
import {onImgError} from "../../../common/utils/function";
import NFTPlaceHolder from "../../../images/nft-placeholder.svg"
import {useTranslation} from "react-i18next";

interface NFTImageProps {
    image?: any,
}

const IMAGE_REGEX = /\.(png|apng|jpeg|jpg|ico|hdr|bmp|webp|gif|tif|jp2|rgb|dds|cur|tga|heic|jfif|pgm|jpe|xpm|exr|map|ppm|g3|wbmp|jbg|pcx|pdb|jps|rgba|heif|fax|xbm|yuv|pcd|pict|xwd|pal|vips|pgx|pbm|jbig|picon|ras|pct|fts|hrz|ipl|mng|mtv|otb|palm|pam|pfm|pnm|rgbo|sgi|sun|uyvy|viff|xv|g4|rgf|six|sixel|jif|jfi)$/i;
const VIDEO_REGEX = /(avi|wmv|mpeg|webm|mov|mpg|divx|mpeg-2|3gp|flv|swf|m4v|ogv|mkv|mjpeg|vob|xvid|mts|av1|avchd|hevc|asf|mxf|m2v|3g2|rmvb|m2ts|wtv|f4v|rm|mp4)$/i;

const NFTImage: FC<NFTImageProps> = (props) => {
    const {t, i18n} = useTranslation();
    const isVideo = useMemo(() => {
        if (!props.image) return false; // Handle when image is null
        const extension = props.image.split(".").pop().toLowerCase();
        return VIDEO_REGEX.test(extension);
    }, [props?.image])

    return <div className="mb-0 w-100 nft-block">
        {isVideo ? <video controls autoPlay loop src={props.image}>{t("Your browser does not support the video tag.")}</video>
            :
            <img src={props?.image ? props?.image : NFTPlaceHolder} onError={onImgError}/>}
    </div>
};

export default NFTImage;
